export interface BoardCall {
  tokenNo: string | null;
  room: string | null;
  at: number;
}

export function callKey(call: BoardCall): string {
  return `${call.tokenNo ?? ''}|${call.room ?? ''}|${call.at}`;
}

export function newCalls(calls: readonly BoardCall[], heard: Set<string>): BoardCall[] {
  const fresh = calls.filter((call) => !heard.has(callKey(call)));
  for (const call of fresh) heard.add(callKey(call));
  return fresh.sort((a, b) => a.at - b.at);
}

const PHRASES: Record<string, (token: string, room: string | null) => string> = {
  en: (token, room) => `Token ${token}${room ? `, please go to room ${room}` : ', please come forward'}`,
  ar: (token, room) => `الرقم ${token}${room ? `، تفضل إلى الغرفة ${room}` : '، تفضل'}`,
  es: (token, room) => `Turno ${token}${room ? `, pase a la sala ${room}` : ', pase por favor'}`,
  'ur-Latn': (token, room) => `Token number ${token}${room ? `, kamra number ${room} mein tashreef laayein` : ', tashreef laayein'}`,
};

export function announcementFor(call: BoardCall, lang: string): string {
  const phrase = PHRASES[lang === 'ur' ? 'ur-Latn' : lang] ?? PHRASES.en;
  return phrase(call.tokenNo ?? '', call.room);
}
